import {
    WEEKLY_STATUS_LOADER,
    GET_WEEKLY_STATUS_HEADER_DATA
  } from "../constants/constants";
  
  const initialState = {
    data: null,
    loader: false,
  };
  
  export const governorReducer = (state = initialState, action) => {
    switch (action.type) {
      case WEEKLY_STATUS_LOADER: {
        return {
          ...state,
          loader: action.payload
        };
      }
      case GET_WEEKLY_STATUS_HEADER_DATA: {
        return {
          ...state,
          data: {...action.payload}
        }
      }
      default:
        return state;
    }
  };